<template>
  <DBox
    :id="'cmp-distribution-suppliers-sidewindow-stock_check_list'"
    :addButton="false"
    :addLink="true"
    :searchButton="true"
    :searchFlag="searchFlag"
    :addLinkLabel="`${$t('Create Supply Order')}`"
    @addClick="onAddClick"
    :rightMenu="[
      {
        text: $t('export'),
        value: 'export',
      },
    ]"
    @searchClick="onSearchClick"
    @menuClick="onRightMenuClick"
  >
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <Dropdown
          :options="related_labelsTV"
          :selected="selectedLabelIds"
          :placeholder="'Select Label'"
          allnone
          multiple
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected(e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
      </div>
    </div>
    <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined,
      }"
    >
      <NTable
        class="dbox1"
        id="distribution-order-sidewindow-backorder"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :showNoItems="false"
      >
        <template v-slot:thead="{ thcon }">
          <tr style="color: var(--text-5)">
            <th v-bind="thcon('label_name')">
              <span>{{ $t("label_name") }} </span>
            </th>
            <th v-bind="thcon('barcode')">
              <div class="ut-fc">
                <span>{{ $t("barcode") }}</span>
                <span>{{ $t("catalog_no") }}</span>
              </div>
            </th>
            <th v-bind="thcon('artist')">
              <div class="ut-fc">
                <span>{{ $t("artist") }}</span>
                <span>{{ $t("ps_title") }}</span>
              </div>
            </th>
            <th v-bind="thcon('format_name')">
              <span> {{ $t("format") }} </span>
            </th>
            <th v-bind="thcon('sales')">
              <span class="ut-text-right">
                {{ $t("sales_last_3_month") }}
              </span>
            </th>
            <th v-bind="thcon('initial_qty')">
              <div class="ut-fc">
                <span>{{ $t("initial_order") }}</span>
                <span>{{ $t("min_stock") }}</span>
              </div>
            </th>
            <th v-bind="thcon('stockQty')">
              <div class="ut-fc">
                <span>{{ $t("stock_qty") }}</span>
                <span>{{ $t("open_supplier_qty") }}</span>
              </div>
            </th>
            <th v-bind="thcon('openOrderQty')">
              <div class="ut-fc">
                <span>{{ $t("open_order_qty") }}</span>
                <span>{{ $t("backorder_qty") }}</span>
              </div>
            </th>
            <th v-bind="thcon('suggestedOrderQty')">
              <div style="white-space: initial">
                {{ $t("suggested_order_qty") }}
              </div>
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item, tdcon }">
          <tr :key="item.artist">
            <td v-bind="tdcon('label_name')">
              <span class="ut-txtov" :title="item['label_name']">{{
                item["label_name"]
              }}</span>
            </td>

            <td v-bind="tdcon('barcode')">
              <div class="ut-fc ut-txtov">
                <span
                  @click="onSelectedProduct(item)"
                  class="txtov ut-link ut-text-accent5"
                  :title="item['barcode']"
                  >{{ item["barcode"] }}</span
                >
                <span
                  @click="onSelectedProduct(item)"
                  class="txtov ut-link ut-text-accent5"
                  :title="item['catalog_no']"
                  >{{ item["catalog_no"] }}</span
                >
              </div>
            </td>

            <td v-bind="tdcon('artist')">
              <div class="ut-fc ut-txtov">
                <span class="ut-txtov" :title="item['artist']">{{
                  item["artist"]
                }}</span>
                <span class="ut-txtov" :title="item['title']">{{
                  item["title"]
                }}</span>
              </div>
            </td>
            <td v-bind="tdcon('format_name')">
              <span class="ut-txtov" :title="item['format_name']">{{
                item["format_name"]
              }}</span>
            </td>
            <td v-bind="tdcon('sales')">
              <span
                style="text-align: right"
                class="ut-txtov"
                :title="item['sales_last_3_month']"
                >{{ item["sales_last_3_month"] }}</span
              >
            </td>
            <!-- <td v-bind="tdcon('quantity')">
            <TextField2
              type="number"
              class="dbox1"
              id="order_qty"
              :showLabel="false"
              :disabled="false"
              :value="item['order_qty']"
              :bb="'none'"
              :ta="'right'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td> -->
            <td v-bind="tdcon('initial_qty')">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-start;
                "
              >
                <TextField2
                  :ta="'right'"
                  :id="'initial_qty'"
                  :showLabel="false"
                  :bb="'0px'"
                  :disabled="item['disabled']"
                  :value="item['initial_qty']"
                  @blur="(e) => onTextFieldValueChange(e, item)"
                />
                <TextField2
                  :ta="'right'"
                  :id="'min_stock'"
                  :bb="'0px'"
                  :showLabel="false"
                  :disabled="item['disabled']"
                  :value="item['min_stock']"
                  @blur="(e) => onTextFieldValueChange(e, item)"
                />
              </div>
            </td>
            <td v-bind="tdcon('stockQty')">
              <div class="ut-fc ut-txtov">
                <span
                  style="text-align: right"
                  class="ut-txtov"
                  :title="item['stock_qty']"
                  >{{ item["stock_qty"] }}</span
                >
                <span
                  style="text-align: right"
                  class="ut-txtov"
                  :title="item['open_supplier_qty']"
                  >{{ item["open_supplier_qty"] }}</span
                >
              </div>
            </td>
            <td v-bind="tdcon('openOrderQty')">
              <div class="ut-fc ut-txtov">
                <span
                  style="text-align: right"
                  class="ut-txtov"
                  :title="item['open_order_qty']"
                  >{{ item["open_order_qty"] }}</span
                >
                <span
                  style="text-align: right"
                  class="ut-txtov"
                  :title="item['backorder_qty']"
                  >{{ item["backorder_qty"] }}</span
                >
              </div>
            </td>
            <td v-bind="tdcon('suggestedOrderQty')">
              <TextField2
                type="number"
                class="dbox1"
                :disabled="true"
                id="suggested_order_qty"
                :showLabel="false"
                :value="item['suggested_order_qty']"
                :bb="'none'"
                :ta="'right'"
                @change="(e) => onTextFieldValueChange(e, item)"
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>
  
  <script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { openWindow } from "../../../../utility";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { distributionSupplierActions } from "../../store/suppliers/actions";
import { distributionSupplierOrderListLDTRoutes } from "../../router/routes";
import FileDownload from "js-file-download";
import { SuppliersService } from "../../services/suppliers.service";
import { productsListLDTRoutes } from "../../../catalog/router/routes";
import { createTV } from "../../../../models/text-value.model";
export default {
  components: {
    DBox,
    NTable,
  },
  props: ["selectedSupplierDetails"],
  data: function () {
    return {
      searchModel: {},
      searchFlag: false,
      related_labels: [],
      selectedLabelIds: [],
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        headerHeight: 52,
        rowHeight: 62,
      }),
    };
  },
  mounted: function () {
    SuppliersService.getSubtabStockCheckData(
      this.selectedSupplierDetails?.supplier?.supplier_id
    ).then((res) => {
      this.related_labels = res.data.related_labels;
    });
  },

  computed: {
    related_labelsTV: function () {
      return createTV(this.related_labels, "label_name", "label_id");
    },
    list: function () {
      return this.selectedSupplierDetails.stocKProducts || [];
    },
    headers: function () {
      return [
        createTableHeader("label_name", { f: 0.7, minw: 120 }),
        createTableHeader("barcode", {}),
        createTableHeader("artist", {}),
        createTableHeader("format_name", { mw: 70 }),
        createTableHeader("sales"),
        createTableHeader("initial_qty"),
        createTableHeader("stockQty"),
        createTableHeader("openOrderQty"),
        createTableHeader("suggestedOrderQty", { mw: 100 }),
      ];
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionSupplierActions),
    onAddClick: function () {
      this.$emit("add_click", "add_new_stock");
    },

    onFilterSelected: function (value) {
      this.selectedLabelIds = value;
      const label_ids =
        this.selectedLabelIds && this.selectedLabelIds.length > 0
          ? this.selectedLabelIds.map((e) => e.value).join(",")
          : undefined;
      this.filter(label_ids);
    },
    filter(label_ids = "") {
      SuppliersService.fetchDistributionSupplierDetailsTabStockCheck(
        this.selectedSupplierDetails?.supplier?.supplier_id,
        label_ids
      ).then((res) => {
        const stocKProducts = res.data.products;
        console.log("stocKProducts", stocKProducts);
        this.$emit("filtered", stocKProducts);
      });
    },
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit("showSearchFlag", this.searchFlag);
    },
    onTextFieldValueChange: async function ({ name, value }, item) {
      const payload = {
        name,
        value,
        kVal: item.product_id,
        table: "l_products",
      };
      const res = await SuppliersService.modify({
        ...payload,
      });
      this.filter();
    },
    onSelectedProduct: function (item) {
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: item.product_id,
          tab: "overview",
        },
      });
    },

    onRightMenuClick: async function (menu) {
      if (menu == "export") {
        const label_ids =
          this.selectedLabelIds && this.selectedLabelIds.length > 0
            ? this.selectedLabelIds.map((e) => e.value).join(",")
            : undefined;
        const res = await SuppliersService.exportStockCheckData(
          this.selectedSupplierDetails?.supplier?.supplier_id,
          label_ids
        );
        console.log({ fileURL: res.data });
        FileDownload(
          res.data,
          `${this.selectedSupplierDetails?.supplier?.supplier_name}.xlsx`
        );
      }
    },
    updateData: function (item) {
      const stocKProducts = this.selectedSupplierDetails.stocKProducts.map(
        (b) => {
          if (b.product_id === item.product_id) {
            b = {
              ...item,
            };
          }
          return b;
        }
      );

      this[ActionTypes.DistributionSupplierStockCheck.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        stocKProducts: stocKProducts || [],
      });
    },
  },
};
</script>
  
  <style lang="scss">
.cmp-distribution-suppliers-sidewindow-stock_check_list {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
    .dropdown {
      margin: 10px;
    }
  }
  .link {
    padding-top: 10px;
  }
  .accounted-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    div {
      margin-right: 5px;
    }
  }
}
</style>
  